import { useEffect, useState } from "react";
import { Card, Col, Row, Empty, InputNumber, Flex  } from "antd";

import CardTitle from "components/Common/CardTitle";
import useFetch from "hooks/useFetch";
import UnitMapCell from "components/Home/UnitMapCell";
import UnitDetailsModal from "./UnitDetailsModal";

const UnitMapCard = ({ itemUuid }) => {
  const { responseData: unitListResponseData, doFetch: getUnitList } = useFetch(
    "/units/getUnitList",
    "GET",
    [],
    false,
    true,
  );
  const [showDetailsModalUnitIndex, setShowDetailsModalUnitIndex] = useState(null);
  const [unitDisplayQuantity, setUnitDisplayQuantity] = useState(144);
  const [intervalId, setIntervalId] = useState();

  const unitListData = unitListResponseData.data ?? [];

  const fetchUnitList = () => {
    getUnitList({
      item: itemUuid,
      page_size: unitDisplayQuantity,
      sorters: ["x-desc"]
    });
  };

  const onClickCell = (index) => {
    setShowDetailsModalUnitIndex(index);
  };

  const handleOnQuantityChange = (value) => {
    setUnitDisplayQuantity(value)
  };

  const onPressEnterQuantity = () => {
    if (!!itemUuid) {
      if (intervalId !== undefined) {
        clearInterval(intervalId)
        setIntervalId(undefined)
      }
      fetchUnitList();
    }
  };
  
  useEffect(() => {
    if (!!itemUuid) {
      if (intervalId !== undefined) {
        clearInterval(intervalId)
        setIntervalId(undefined)
      }
      fetchUnitList();
    }
  }, [itemUuid]);

  useEffect(()=>{
    if(!!itemUuid && intervalId === undefined){
      setIntervalId(
        setInterval(
          ()=>{fetchUnitList();}
          ,100
        )
      )
    }
  },[unitListData])

  useEffect(()=>{
    return() => {
      if(intervalId !== undefined){
        clearInterval(intervalId)
        setIntervalId(undefined)
      }
    };
  },[intervalId])

  return (
    <>
      <Card style={{maxHeight: "75%"}}>
        <CardTitle 
          title={"Map Unit Progress"} 
          tools={
            <Flex gap="small">
              <span>Display quantity : </span>
              <InputNumber controls={false} defaultValue={144} min={0} max={504} value={unitDisplayQuantity} onChange={handleOnQuantityChange} onPressEnter={onPressEnterQuantity} parser={(value)=>{return parseInt(value, 10)}} size="small"/>
            </Flex>
          }
        />
        {itemUuid === undefined? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>:<Row wrap={true} gutter={[2, 8]} style={{display: 'flex', flexDirection: 'row-reverse'}}>
          {unitListData.map((data, index) => (
            <Col key={index} span={2}>
              <UnitMapCell data={data} onClick={() => onClickCell(index)} />
            </Col>
          ))}
        </Row>}
      </Card>
      <UnitDetailsModal
        showModal={showDetailsModalUnitIndex !== null}
        data={unitListData?.[showDetailsModalUnitIndex] ?? {}}
        onClose={() => setShowDetailsModalUnitIndex(null)}
        showDetailsModalUnitIndex={showDetailsModalUnitIndex}
      />
    </>
  );
};

export default UnitMapCard;
